import { workSetCheckGroupsLinkAPI } from "@/views/WorkSetCheckGroupsLink/api";

export const getWorkSetCheckGroupsLink = async () => {
  const res = await workSetCheckGroupsLinkAPI.getList();
  return res?.data || [];
};

export const addWorkSetCheckGroupsLink = async (body) => {
  try {
    const res = await workSetCheckGroupsLinkAPI.add(body);
    return res?.data;
  } catch (e) {}
};

export const updateWorkSetCheckGroupsLink = async (id, body) => {
  const updatedBody = {
    prev_work_set_check_group_id: body.prev_work_set_check_group_id,
    work_set_check_group_id: body.work_set_check_group_id,
    company_id: body.company_id,
  };

  try {
    const res = await workSetCheckGroupsLinkAPI.update(id, updatedBody);
    return res?.data;
  } catch (e) {}
};

export const deleteWorkSetCheckGroupsLink = async (id) => {
  try {
    const res = await workSetCheckGroupsLinkAPI.delete(id);
    return res?.data;
  } catch (e) {}
};

export const workSetCheckGroupsLinkColumns = [
  {
    name: "work_set_check_group_link_id",
    field: "work_set_check_group_link_id",
    label: "ID связи",
    align: "center",
  },
  {
    name: "work_set_check_group_name",
    field: "work_set_check_group_name",
    label: "Текущая рабочая группа",
    align: "center",
  },
  {
    name: "prev_work_set_check_group_name",
    field: "prev_work_set_check_group_name",
    label: "Предыдущая рабочая группа",
    align: "center",
  },
  {
    name: "company_name",
    field: "company_name",
    label: "Название компании",
    align: "center",
  },
  {
    name: "rowversion",
    field: "rowversion",
    label: "Дата изменения",
    align: "center",
  },
];
